import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaHistoricoComponent } from "./aba-historico.component";

@NgModule({
    declarations: [AbaHistoricoComponent],
    imports:[SharedModule],
    exports:[AbaHistoricoComponent]
})
export class AbaHistoricoModule {}